import React, { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// components
import BaseInput from 'components/inputs/base-input';

interface OwnProps {
  name: string;
  label: string;
  withError?: boolean;
  separateLabel?: boolean;
  [x: string]: any;
}

const BaseInputController: React.FC<OwnProps> = ({
  name = '',
  defaultValue = '',
  withError,
  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
        <BaseInput
          {...props}
          value={value}
          variant="filled"
          error={!!error}
          onBlur={onBlur}
          onChange={onChange}
          helperText={withError ? error?.message || ' ' : ' '}
        />
      )}
      name={name}
      control={control}
      defaultValue={defaultValue}
    />
  );
};

export default memo(BaseInputController);
